import React, { useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

// Data for the cards
const cardData = [
  {
    imageUrl: "/assets/edu-training/Objectives.jpg",
    title: "Our Objectives",
    desc: "A holistic value-based initiative fostering goodness, responsibility, mentorship, cultural preservation, and balanced personal growth to nurture inspired, ethical leaders.",
    link: "/objectives",
  },
  {
    imageUrl: "/assets/edu-training/values.png",
    title: "Education & Training",
    desc: "A four-phase journey of value-based education—awareness, education, cultivation, and action—guiding students from interest to embodiment of core values.",
    link: "/values",
  },
];

// The main parent component
const AnimatedCardContainer = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <div className="card-section-container">
      <div className="card-grid" ref={ref}>
        {cardData.map((card, index) => (
          <Card
            key={index}
            card={card}
            index={index}
            isInView={isInView}
          />
        ))}
      </div>
    </div>
  );
};

// The new individual Card component with all the cool effects
const Card = ({ card, index, isInView }) => {
  const cardRef = useRef(null);
  const [style, setStyle] = useState({});

  const handleMouseMove = (e) => {
    const { clientX, clientY } = e;
    const { left, top, width, height } = cardRef.current.getBoundingClientRect();
    const x = clientX - left;
    const y = clientY - top;
    
    // 3D Tilt Effect
    const rotateX = (y / height - 0.5) * -20; // Max rotation 10deg
    const rotateY = (x / width - 0.5) * 20;   // Max rotation 10deg

    // Mouse-following Glow
    const glowX = (x / width) * 100;
    const glowY = (y / height) * 100;

    setStyle({
      transform: `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.05, 1.05, 1.05)`,
      '--glow-x': `${glowX}%`,
      '--glow-y': `${glowY}%`,
    });
  };

  const handleMouseLeave = () => {
    setStyle({
      transform: 'perspective(1000px) rotateX(0) rotateY(0) scale3d(1, 1, 1)',
    });
  };

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.8, y: 50 },
    visible: { opacity: 1, scale: 1, y: 0 },
  };

  return (
    <motion.div
      ref={cardRef}
      className="magic-card"
      variants={cardVariants}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      transition={{ duration: 0.6, ease: "easeOut", delay: index * 0.2 }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={style}
    >
      <div className="card-content">
        <div className="card-image-container">
          <img src={card.imageUrl} alt={card.title} className="card-image" />
        </div>
        <div className="card-text-content">
          <h2>{card.title}</h2>
          <p>{card.desc}</p>
          {card.link && (
            <a href={card.link} className="card-link">
              <motion.button
                className="cast-btn"
                whileHover={{ scale: 1.1, y: -2 }}
                whileTap={{ scale: 0.95 }}
              >
                Know More
              </motion.button>
            </a>
          )}
        </div>
      </div>
      <div className="card-glow" />
      <div className="card-border" />
    </motion.div>
  );
};

export default AnimatedCardContainer;